import { ReactNode, useContext } from 'react';

import WorkOrdersContext, {
  FilterSection,
} from '@atom/components/workOrders/WorkOrdersContext';
import { Icon, IconButton } from '@atom/mui';
import {
  Client,
  getCurrentClient,
  MAL_EMULATION_CLIENT,
} from '@atom/utilities/featureToggleUtilities';
import { toggleFromSet } from '@atom/utilities/setUtilities';

import WorkFilterLocationAldotFilters from './WorkFilterLocationAldotFilters';
import WorkFilterLocationUdotFilters from './WorkFilterLocationUdotFilters';

import classes from './workOrdersFilters.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

const WorkOrdersFiltersLocationSection = () => {
  const { collapsedSections, setCollapsedSections } =
    useContext(WorkOrdersContext);

  const onToggle = (section: FilterSection) => {
    setCollapsedSections(toggleFromSet(collapsedSections, section));
  };

  const getTenantInputs = (): ReactNode => {
    const currentClient = getCurrentClient(MAL_EMULATION_CLIENT);

    switch (currentClient) {
      case Client.UDOT:
        return <WorkFilterLocationUdotFilters />;
      case Client.ALDOT:
        return <WorkFilterLocationAldotFilters />;
      default:
        return <></>;
    }
  };

  return (
    <div className={classes.filtersSection}>
      <div className={classes.filtersSectionHeader}>
        <div>
          <Icon style={styles.icon}>pin</Icon>
          Locations
        </div>
        <IconButton
          onClick={() => onToggle(FilterSection.LOCATIONS)}
          edge="end"
        >
          <Icon>
            {collapsedSections.has(FilterSection.LOCATIONS)
              ? 'keyboard_arrow_down'
              : 'keyboard_arrow_up'}
          </Icon>
        </IconButton>
      </div>
      {!collapsedSections.has(FilterSection.LOCATIONS) && (
        <div className={classes.filtersSectionContent}>{getTenantInputs()}</div>
      )}
    </div>
  );
};

export default WorkOrdersFiltersLocationSection;
